import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalService } from '../services/modal.service';
import { ModalStates } from '../models/modal';
import { FlattenResponseMessages } from '../utils/api-response-helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Inject, Injectable, NgZone } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  // FIXME: replace skipUrls with errorInterceptorSkipHeader
  // see admin service checkMobilePhone for an example
  skipUrls = [`${this.env.apiUrlRoot}/Banks`, `${this.env.apiUrlRoot}/Audit`];

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private ngbModalService: NgbModal,
    @Inject('env') private env: any,
    @Inject('errorInterceptorSkipHeader') private errorInterceptorSkipHeader: any,
    @Inject('loginRedirectSkipHeader') private loginRedirectSkipHeader: any,
    private ngZone: NgZone,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        let msg = '';
        let show = true;

        // FIXME: remove deprecated skipUrls. use errorInterceptorSkipHeader
        this.skipUrls.forEach(x => {
          if (request.url.startsWith(x)) {
            show = false;
          }
        });

        if (response.status == 401 && !request.headers.has(this.loginRedirectSkipHeader)) {
          sessionStorage.removeItem('apollo-user');
          this.ngZone.run(() => {
            this.authService.forceLoggedOutState();
            this.router.navigate(['/logged-out']);
          });

          show = false;
        }
        if (response.status == 403) {
          this.ngZone.run(() => {
            this.router.navigate(['/access-denied']);
          });

          show = false;
        }
        if (response.status == 418) {
          this.ngZone.run(() => {
            this.router.navigate(['/logged-out']);
          });

          show = false;
        }

        if (request.headers.has(this.errorInterceptorSkipHeader)) {
          request.headers.delete(this.errorInterceptorSkipHeader);
          show = false;
        }

        if (show) {
          if (response.error && response.error.Message) {
            const m = FlattenResponseMessages(response.error.Details);
            msg = `${response.error.Message}\n` + m.Body;
          } else {
            msg = `Error Code: ${response.status}\nMessage: ${response.message}`;
          }

          this.ngbModalService.dismissAll();
          this.modalService.showAlertModal(msg, ModalStates.Error);
          return throwError(msg);
        } else {
          return throwError(response.error);
        }
      })
    );
  }
}
